import React from 'react'

export default function UpdateUser() {
  return (
    <div className='container wrappingDiv my-5 p-5'>
      <h1 style={{justifyContent:'center',margin:"5cm"}}>We will enable soon..</h1>
    </div>
  )
}
